import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-admin-committees-edit',
  templateUrl: './admin-committees-edit.component.html'
})
export class AdminCommitteesEditComponent implements OnChanges, OnInit {
  @Input() formdata;
  @Input() types;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: ['', ''],
      abbreviation: ['', ''],
      name: ['', ''],
      sort: ['', '']
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formdata.currentValue) {
      this.form?.patchValue(changes?.formdata.currentValue);
    }
  }

  saveCommittee() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }
}
